// extracted by mini-css-extract-plugin
export var blink = "styles-module--blink--nSGyx";
export var c_logos = "styles-module--c_logos--KhQ6z";
export var icon = "styles-module--icon--izORe";
export var logo = "styles-module--logo--uWylt";
export var logos = "styles-module--logos--GEE8v";